// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../services/axiosInstance";
import { apiCall } from "../utils/utils";

//! not used
// fetch all studios
export const fetchStudios = createAsyncThunk(
  "studio/fetchStudios",
  async (_, { rejectWithValue }) =>
    apiCall(() => axiosInstance.get("studio/all/"), rejectWithValue),
);

// Get user studios
export const fetchUserStudios = createAsyncThunk(
  "studio/fetchUserStudios",
  async (_, { rejectWithValue }) =>
    apiCall(() => axiosInstance.get("studio/user/"), rejectWithValue),
);

// fetch studio by uuid
export const fetchStudioByUuid = createAsyncThunk(
  "studio/studioByUuid",
  async (studioUuid, { dispatch, rejectWithValue }) => {
    try {
      const studio = await apiCall(
        () => axiosInstance.get(`studio/${studioUuid}`),
        rejectWithValue,
      );
      if (!studio) {
        throw new Error("Studio not found");
      }
      // Fetch studio members
      await dispatch(fetchStudiosMembers(studio.studio_uuid));
      // Fetch studio equipments
      await dispatch(fetchStudioEquipments(studio.studio_uuid));

      return studio;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// get studio members
export const fetchStudiosMembers = createAsyncThunk(
  "studio/fetchStudioMember",
  async (studioUuid, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.get(`studio/studio-members/${studioUuid}/`),
      rejectWithValue,
    ),
);

// STUDIO MEMBERS
// add member to studio
export const addStudioMember = createAsyncThunk(
  "studio/addShowMember",
  async (data, { rejectWithValue }) => {
    return await apiCall(
      () => axiosInstance.post(`studio/add/member/`, data),
      rejectWithValue,
    );
  },
);

// remove member from studio
export const removeStudioMember = createAsyncThunk(
  "studio/removeShowMember",
  async ({ studioMemberId }, { rejectWithValue }) => {
    try {
      await apiCall(() =>
        axiosInstance.delete(`studio/remove/member/${studioMemberId}/`),
      );
      return { studioMemberId };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// STUDIO SCENES
// add scene to studio
export const addSceneToStudio = createAsyncThunk(
  "studio/addSceneToStudio",
  async (data, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.post(`studio/add/scene/`, data),
      rejectWithValue,
    ),
);

// remove scene from studio
export const removeSceneFromStudio = createAsyncThunk(
  "studio/removeSceneFromStudio",
  async (studioSceneId, { rejectWithValue }) => {
    try {
      await apiCall(
        () => axiosInstance.delete(`studio/remove/scene/${studioSceneId}/`),
        rejectWithValue,
      );
      return studioSceneId;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// STUDIO EQUIPMENT
// get studio equipments
export const fetchStudioEquipments = createAsyncThunk(
  "equipments/fetchStudioEquipments",
  async (studioUuid, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.get(`studio_equipment/${studioUuid}/`),
      rejectWithValue,
    ),
);

// Add equipment to studio
//! data returned it s not the same as company.company_equipment object
//! missing name and co_equip object
export const addEquipmentToStudio = createAsyncThunk(
  "equipments/addEquipmentToStudio",
  async (data, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.post(`studio/add/equipment/`, data),
      rejectWithValue,
    ),
);

//! ATM not used
// Update equipment from studio
export const updateEquipmentFromStudio = createAsyncThunk(
  "equipments/updateEquipmentFromStudio",
  async (data, { rejectWithValue }) =>
    apiCall(
      () => axiosInstance.patch(`studio/update/equipment/`, data),
      rejectWithValue,
    ),
);

// delete equipment from studio
export const deleteEquipmentFromStudio = createAsyncThunk(
  "equipments/deleteEquipmentFromStudio",
  async (studioEquipmentId, { rejectWithValue }) =>
    apiCall(
      () =>
        axiosInstance.delete(`studio/remove/equipment/${studioEquipmentId}/`),
      rejectWithValue,
    ),
);

// Test websocket event message
export const testWebSocketEvent = createAsyncThunk(
  "studio/testWebSocketEvent",
  async ({ studioUUID, sceneUUID }, { rejectWithValue }) => {
    try {
      const response = await apiCall(
        () =>
          axiosInstance.get(
            `dev/download_progress/${studioUUID}/${sceneUUID}/`,
          ),
        rejectWithValue,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
